import { VPN_STATUSES_ICON_MAP, VPN_STATUSES_TITLES } from '@/common/constants/vpn.constants';

export default function createVpn(vpn, getters, rootGetters) {
  const project = typeof rootGetters['projects/getItemById'] === 'function'
    ? rootGetters['projects/getItemById'](vpn.project_id)
    : undefined;

  const remoteEPGroup = getters.getEndpointsGroups.find(it => it.id === vpn.peer_ep_group_id);
  const localEPGroup = getters.getEndpointsGroups.find(it => it.id === vpn.local_ep_group_id);
  const ipSecPolicy = getters.getPolicies('ipsec').find(it => it.id === vpn.ipsecpolicy_id);
  const ikePolicy = getters.getPolicies('ike').find(it => it.id === vpn.ikepolicy_id);
  const vpnService = getters.getVpnServiceInfo(vpn.vpnservice_id);

  return {
    ...vpn,
    remoteEPGroup,
    localEPGroup,
    ipSecPolicy,
    ikePolicy,
    project,
    vpnService,
    projectId: vpn.project_id,
    statusText: VPN_STATUSES_TITLES[vpn.status],
    statusIcon: VPN_STATUSES_ICON_MAP[vpn.status],
    remoteEPGroupName: remoteEPGroup?.name,
    localEPGroupName: localEPGroup?.name,
    ipSecPolicyName: ipSecPolicy?.name,
    ikePolicyName: ikePolicy?.name,
    // eslint-disable-next-line camelcase
    routerId: vpnService?.router_id
  };
}
